import React from 'react';
import PropTypes from 'prop-types';

const Label = ({ className, label, id, isRequired, isHidden }) => {
  return (
    <label
      className={`${className} ${isHidden ? 'visuallyHidden' : ''}`}
      htmlFor={id}
    >
      {label}
      {isRequired ? <span className='label__required'>(required)</span > : <span className='label__optional'>(optional)</span>}
    </label>
  );
};

Label.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isHidden: PropTypes.bool,
};

export default Label;
